jQuery(document).ready(function ($) {

    $(document).on('click', '.collapsible-article__header', function () {
        var $collapsible = $(this).parent();

        if ($collapsible.hasClass('is-active--collapsible')) {
            $collapsible.removeClass('is-active--collapsible').children('.collapsible-article__content').stop().slideUp(300);
        } else {
            $collapsible.addClass('is-active--collapsible').children('.collapsible-article__content').stop().slideDown(300);
        }
    });

    var open = true;
    $(window).on("load resize",function(e){
        if(screen.width < 768 && open){
            $('.collapsible-article.is-active--collapsible > .collapsible-article__content').show();
            $('.collapsible-article:not(.is-active--collapsible) > .collapsible-article__content').hide();
            open = false;
        }
        if(screen.width > 767 && !open){
            $('.collapsible-article > .collapsible-article__content').show();
            open = true;
        }
    });

});
